import { render, staticRenderFns } from "./body.vue?vue&type=template&id=2087f01c&"
import script from "./body.vue?vue&type=script&lang=js&"
export * from "./body.vue?vue&type=script&lang=js&"
import style0 from "./body.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports